/**
 * This JavaScript module enhances the checkout process on a webpage by ensuring that users cannot proceed to checkout
 * if there have been changes made to the form that have not been saved. It listens for the DOMContentLoaded event to
 * initialize, then monitors the specified form for changes. If the user attempts to proceed to checkout and there are
 * unsaved changes, an alert prompts them to save their changes first. This is achieved by comparing the initial form
 * values with the values at the time the checkout button is clicked, using a SHA-256 hash for accurate comparison.
 */
// export function initializePriceCalculation() {
import { initializePriceCalculation } from './custom-javascript.js';

jQuery(function ($) {

    // form id cart-order-options-form
    const form = jQuery("#cart-order-options-form");

    // input #save-project-options
    const submitButton = jQuery("input#save-project-options");

    // if any field changes, click submit
    form.on("change", function () {
        submitButton.trigger("click");
        console.log("form changed");

        
    });

    jQuery("div.woocommerce").on("change keyup mouseup", "input.qty, select.qty", function () { // keyup and mouseup for Firefox support
        console.log("qty changed");
        if (jQuery(this).val() == "") return;
        jQuery("[name=\"update_cart\"]").trigger("click");
    });

    jQuery("div.woocommerce").on("change", ".ppl-input-field input.form-control", function () {
        console.log("ppl input changed");
        jQuery("[name=\"update_cart\"]").trigger("click");
    });

});
